import { useEffect } from 'react';
import { t } from '@/l10n/strings';

/** The browser tab's title: "Invoices · Paidlark". */
export function usePageTitle(title: string | null | undefined) {
  useEffect(() => {
    document.title = title ? `${title} · ${t('appName')}` : t('appName');
  }, [title]);
}
